import React from 'react';
import { ArrowRight, Phone } from 'lucide-react';
import { company } from '../data/site';
import { Reveal } from './Reveal';
export function CtaBanner() {
  return <section className="w-full bg-brand-500" data-id="element-135" data-mp="18j8ehfofhycz">
      <div className="mx-auto flex max-w-[1400px] flex-col gap-8 px-5 py-16 sm:px-8 lg:flex-row lg:items-center lg:justify-between lg:py-20" data-id="element-136" data-mp="13n1l0md7yfbx">
        <Reveal data-id="element-137" data-mp="yksq3kgsd376">
          <h2 className="max-w-2xl font-heading text-3xl font-extrabold uppercase leading-[1.05] tracking-tight text-white sm:text-4xl" data-id="element-138" data-mp="1wankpjjbszti">
            Planning a project? Start with a free estimate.
          </h2>
          <p className="mt-4 max-w-xl text-white/80" data-id="element-139" data-mp="1mc7xhrnf6apa">
            No pressure, no obligation — just an honest conversation about scope, timeline, and cost.
          </p>
        </Reveal>
        <Reveal delay={0.1} data-id="element-140" data-mp="axb4y7s113d6">
          <div className="flex flex-col gap-3 sm:flex-row" data-id="element-141" data-mp="axkszptih0g8">
            <a href="#contact" className="group inline-flex items-center justify-center gap-3 bg-white px-8 py-5 text-[13px] font-bold uppercase tracking-[0.16em] text-navy transition hover:bg-navy hover:text-white" data-id="element-142" data-mp="auyf78g11opk">
              Get a Free Estimate
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" aria-hidden="true" data-id="element-143" data-mp="1g5jfyomx3gh6" />
            </a>
            <a href={company.phoneHref} className="inline-flex items-center justify-center gap-3 border border-white/50 px-8 py-5 text-[13px] font-bold uppercase tracking-[0.16em] text-white transition hover:border-white hover:bg-brand-600" data-id="element-144" data-mp="168wv3zulcpf5">
              <Phone className="h-4 w-4" aria-hidden="true" data-id="element-145" data-mp="ikndzb8bopuc" />
              {company.phone}
            </a>
          </div>
        </Reveal>
      </div>
    </section>;
}